import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'
import { PublicInterceptor } from '../../../Base/interceptors/PublicInterceptor';

// GET Posiciones
export const getPosiciones = async () => {
    const result = await PrivateInterceptor(`Payrolls/Posiciones`, 'GET');
    return result;
}

export const getPosicionesToken = async (token) => {
    const result = await PublicInterceptor(`Payrolls/Posiciones`, 'GET', undefined, token);
    return result;
}